import React from "react";
import "components/Tribe/Friends/UserDetail/FriendNewsfeed/Reaction.css";
import Image from "react-bootstrap/Image";
import ButtonBase from "@material-ui/core/ButtonBase";

function ReactionSelectGrid(props) {
  return (
    <div className="reaction_grid_container">
      <div className="reaction_grid">
        {props.reactions.map((elem) => (
          <ButtonBase
            key={elem.id}
            onClick={() => props.onImageClick(elem.id)}
            style={{ borderRadius: "10px" }}
          >
            <Image key={elem.id} src={elem.image} />
          </ButtonBase>
        ))}
      </div>
    </div>
  );
}

export default ReactionSelectGrid;
